import React from 'react';
import LockIcon from '@material-ui/icons/Lock';

const ActiveSessionLockBanner = ({ sessionId }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      margin: '16px 24px',
      padding: '14px 18px',
      borderRadius: 8,
      backgroundColor: '#fff4e5',
      border: '1px solid #ffb74d',
      color: '#7a3e00',
      fontSize: 14,
    }}
  >
    <LockIcon fontSize="small" />
    <span>
      Reading Session <strong>#{sessionId}</strong> is currently active.
      Setup is locked until the session is ended.
    </span>
  </div>
);

export default ActiveSessionLockBanner;
